var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoupas = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6003 18.2002L13.0003 11.7502V10.8402C14.6503 10.3502 15.8003 8.67016 15.4303 6.79016C15.1703 5.48016 14.1303 4.39016 12.8203 4.09016C10.5403 3.57016 8.50026 5.30016 8.50026 7.50016H10.5003C10.5003 6.67016 11.1703 6.00016 12.0003 6.00016C12.8303 6.00016 13.5003 6.67016 13.5003 7.50016C13.5003 8.34016 12.8103 9.02016 11.9703 9.00016C11.4303 8.99016 11.0003 9.45016 11.0003 9.99016V11.7502L2.40026 18.2002C1.63026 18.7802 2.04026 20.0002 3.00026 20.0002H12.0003H21.0003C21.9603 20.0002 22.3703 18.7802 21.6003 18.2002ZM6.00026 18.0002L12.0003 13.5002L18.0003 18.0002H6.00026Z",
    fill: "#FF8B22"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoupas);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/roupas.6731ba897602ebee16440a0299556337.svg";